interface DraftDevice {
  deviceDto?: {
    name?: string;
    id?: string;
    physicalSchema?: {
      elementIndex?: number;
      onDevices?: string[];
      toDevices?: string[];
      relatedDevices?: string[];
      isIndependent?: boolean;
      primaryFlowSensor?: string;
      primaryPressureSensor?: string;
    };
    attributes?: Record<string, unknown>;
    additionalAttributes?: Record<string, unknown>;
    deviceModelOverrides?: Record<string, unknown>;
  };
  deviceTypes?: string[];
}

interface PidDevice {
  name?: string;
  deviceId?: string;
  elementIndex: number;
  onDevices: string[];
  toDevices: string[];
  relatedDevices?: string[];
  isIndependent?: boolean;
  primaryFlowSensor?: string;
  primaryPressureSensor?: string;
  deviceTypes?: string[];
  [key: string]: unknown;
}

const convertDraftDeviceToPidDeviceGeneric = (draftDevice: DraftDevice): PidDevice => {
  const { deviceDto, deviceTypes } = draftDevice;

  // Create the base PidDevice structure
  const pidDevice: PidDevice = {
    name: deviceDto?.name,
    deviceId: deviceDto?.id,
    elementIndex: deviceDto?.physicalSchema?.elementIndex || 0,
    onDevices: deviceDto?.physicalSchema?.onDevices || [],
    toDevices: deviceDto?.physicalSchema?.toDevices || [],
    relatedDevices: deviceDto?.physicalSchema?.relatedDevices,
    isIndependent: deviceDto?.physicalSchema?.isIndependent,
    primaryFlowSensor: deviceDto?.physicalSchema?.primaryFlowSensor,
    primaryPressureSensor: deviceDto?.physicalSchema?.primaryPressureSensor,
    deviceTypes: deviceTypes,
  };

  // Flatten device attributes to root level
  if (deviceDto?.attributes) {
    Object.assign(pidDevice, deviceDto.attributes);
  }

  // Flatten additional attributes if present
  if (deviceDto?.additionalAttributes) {
    Object.assign(pidDevice, deviceDto.additionalAttributes);
  }

  // Add device model overrides if present
  if (deviceDto?.deviceModelOverrides) {
    Object.assign(pidDevice, deviceDto.deviceModelOverrides);
  }

  return pidDevice;
};

export const convertDraftDevicesToPidDevicesGeneric = (draftDevices: DraftDevice[]): PidDevice[] => {
  return draftDevices.map(draftDevice => convertDraftDeviceToPidDeviceGeneric(draftDevice));
};

export const SPECIFIC_POWER_THRESHOLD = 1000;
